module.exports = __webpack_public_path__ + "media/images/social-icons/download-bd587c9338be3f7b7b07b013b0d711d2.svg";